import { COLUMN_SIZE } from '../DataGridDevEx/DataGrid.constants';

export const getCustomerPricingLookupColumns = () => [
    {
        dataField: 'Details.PriceCode',
        caption: 'Price code',
        allowResizing: true,
        minWidth: COLUMN_SIZE.PriceField,
        width: COLUMN_SIZE.PriceField,
        fixed: false
    },
    {
        dataField: 'Details.Description',
        caption: 'Description',
        allowResizing: true,
        minWidth: COLUMN_SIZE.Description,
        width: COLUMN_SIZE.Description,
        fixed: false
    },
    {
        dataField: 'Details.Price',
        caption: 'Price',
        allowResizing: true,
        minWidth: COLUMN_SIZE.PriceField,
        width: COLUMN_SIZE.PriceField,
        fixed: false
    },
    {
        dataField: 'Details.Discount',
        caption: 'Discount (%)',
        allowResizing: true,
        minWidth: COLUMN_SIZE.PriceField,
        width: COLUMN_SIZE.PriceField,
        fixed: false
    },
    {
        dataField: 'Details.Nett',
        caption: 'Nett',
        allowResizing: true,
        minWidth: COLUMN_SIZE.PriceField,
        width: COLUMN_SIZE.PriceField,
        fixed: false
    }
];
export const SEARCH_SCREEN_DIALOG_STYLE = {
    width: 'calc(100%)',
    maxWidth: '1000px',
    height: 'calc(100% - 300px)',
    maxHeight: 'calc(100% - 300px)',
};
